// extracted by mini-css-extract-plugin
export var md = "_4t-4";
export var semantic = "_4t-5";
export var sm = "_4t-3";
export var text = "_4t-6";
export var toggleInput = "_4t-0";
export var toggleSwitch = "_4t-1";
export var xs = "_4t-2";